export type FormFieldEntry =
  | string
  | string[]
  | boolean
  | { [key: string]: string | boolean };

export const requiredFieldsFilled = (
  fields: { [key: string]: FormFieldEntry },
  required: string[]
): boolean => {
  if (required.length === 0) {
    return true;
  }

  if (requiredFieldMissingInProvidedFields(fields, required)) {
    return false;
  }

  return !requiredFieldEmpty(fields, required);
};

const requiredFieldMissingInProvidedFields = (
  fields: { [key: string]: FormFieldEntry },
  required: string[]
): boolean =>
  !!required.find((required) => !Object.keys(fields).includes(required));

const requiredFieldEmpty = (
  fields: { [key: string]: FormFieldEntry },
  required: string[]
): boolean => {
  return !!Object.keys(fields).find((key) => {
    if (Array.isArray(fields[key])) {
      const arrayField = fields[key] as string[];
      return arrayField.length === 0 && required.includes(key);
    } else {
      return !fields[key] && required.includes(key);
    }
  });
};
